import { useQuery, useQueries } from "@tanstack/react-query";

import service from "../../../services/volunteerScientistService";
import { recordError } from "../../../utils/logService";

export const useVolScienceRetrieval = () => {
  const results = useQueries({
    queries: [
      {
        queryKey: ["volunteer-science-view"],
        queryFn: () => service.getVolunteerScientistProfile(),
        onError: (error) => recordError(error),
      },
    ],
  });

  return {
    volunteerScientistProfile: results[0],
  };
};